import axios from "axios";
import { getBaseUrl } from "../environment-url";
import store from "../../store/store";

const SESSION_ID_HEADER_KEY = "x-session-id";

const RANDORA_API = axios.create({
    baseURL: getBaseUrl(process.env.REACT_APP_NODE_ENV, "RANDORA_API"),
    responseType: "json",
    withCredentials: false,
    timeout: 10000, // 10 seconds
});

//Add a response interceptor
RANDORA_API.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error.response && error.response.status === 401) {
            console.log("***********Unauthorized Error**********");
        }
        return Promise.reject(error);
    }
);

export default RANDORA_API;

